import styled from 'styled-components/macro'

export const NotFoundWrapper = styled.section`
  width: 100%;
`
export const NotFoundContent = styled.div`
  font-family: roboto;
  text-align: center;
  padding: 5rem 0;
`

export const NotFoundImg = styled.img`
  padding-bottom: 2.4rem;
`

export const NotFoundTitle = styled.h3`
  margin-bottom: 0.8rem;
  font-size: 1rem;
`

export const NotFoundText = styled.p`
  font-size: 0.6rem;
  line-height: 0.9rem;
  margin-bottom: 1rem;
`
